export default {
    bind: function (el, _, vnode) {
        // uppercase transform

        el.transformUpper = function () {
            const start = el.selectionStart
            el.value = el.value.toUpperCase()
            console.log(start)
            el.setSelectionRange(start, start)
            vnode.componentInstance.$emit('input', el.value.toUpperCase())
        }
        // add event listener
        el.addEventListener('input', function () {
            el.transformUpper()
        })
    },
    unbind: function (el) {
        el.removeEventListener('input', el.transformUpper)
    }
}